"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const __1 = require("../");
const icons_1 = require("../../icons");
const ProfileButton = ({ loading, avatar, avatarSize, goToProfile, signOut }) => {
    const avatarSrc = loading ? '' : avatar;
    const menuItems = loading
        ? []
        : [
            {
                label: 'Profile',
                icon: jsx_runtime_1.jsx(icons_1.Icon, { name: "CircleProfile", size: 20 }, void 0),
                onClick: goToProfile
            },
            {
                label: 'Sign out',
                icon: jsx_runtime_1.jsx(icons_1.Icon, { name: "Signout", size: 20 }, void 0),
                onClick: signOut
            }
        ];
    return (jsx_runtime_1.jsx(__1.Popover, Object.assign({ avatarButton: true, avatarSize: avatarSize, avatarSrc: avatarSrc, loading: loading }, { children: menuItems.map(item => (jsx_runtime_1.jsx(__1.PopoverMenuItem, Object.assign({ onClick: item.onClick, icon: item.icon, dataCy: item.label }, { children: item.label }), item.label))) }), void 0));
};
exports.ProfileButton = ProfileButton;
exports.default = react_1.memo(exports.ProfileButton);
//# sourceMappingURL=index.js.map